import { useQuery, gql } from "@apollo/client"
import { ARTIST_ADDRESSES, PROJECTS_PER_PAGE } from "config"
import { OrderDirection } from "utils/types"

interface ProjectsQueryParams {
  first?: number
  skip?: number
  orderDirection?: OrderDirection
}

const artistAddressFilter = ARTIST_ADDRESSES.map((address) => `"${address.toLowerCase()}"`).join(", ")

const projectsQuery = ({ first, skip, orderDirection}: ProjectsQueryParams) => `
  query GetProjects {
    projects(
        where: {
          artistAddress_in: [${artistAddressFilter}]
          active: true
        }
        first: ${first}
        skip: ${skip}
        orderBy: createdAt
        orderDirection: ${orderDirection}
    ) {
      id
      contract {
        id
      }
      projectId
      name
      description
      license
      locked
      pricePerTokenInWei
      active
      paused
      complete
      artistName
      artistAddress
      invocations
      maxInvocations
      scriptJSON
      aspectRatio
      currencyAddress
      currencySymbol
      createdAt
      activatedAt
      tokens (first:10 orderBy: createdAt orderDirection: asc) {
        id
        tokenId
        invocation
      }
      minterConfiguration {
        basePrice
        priceIsConfigured
        currencySymbol
        currencyAddress
        extraMinterDetails
      }
    }
  }`

const useProjects = (params?: ProjectsQueryParams) => {
  const first = params?.first || PROJECTS_PER_PAGE
  const skip = params?.skip || 0
  const orderDirection = params?.orderDirection || OrderDirection.DESC
  const { loading, error, data } = useQuery(gql(projectsQuery({ first, skip, orderDirection})))

  return {
    loading,
    error,
    data
  }
}

export default useProjects
